import { Component, OnInit, inject } from '@angular/core';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { DeployWebappComponent } from '../deploy-webapp/deploy-webapp.component';
import { VersionStatus } from 'src/app/Shared/versionStatus';
import { MaintenanceModeToggleComponent } from '../maintenance-mode-toggle/maintenance-mode-toggle.component';
import { ServerService, ServerStatus } from 'src/services/server.service';
import { Enums } from 'src/app/Shared/enums';

@Component({
    selector: 'app-server-status-page',
    templateUrl: './server-status-page.component.html',
    styleUrls: ['./server-status-page.component.scss'],
    standalone: false
})
export class ServerStatusPageComponent implements OnInit {
  protected sharedService = inject(SharedService);
  protected versionStatus = inject(VersionStatus);
  private serverService = inject(ServerService);
  protected enums = inject(Enums);

  serverStatus: ServerStatus;
  signedInUserList: string[] = [];

  errorCode: string;
  errorLogList: string[] = [];

  time = 10;

  ngOnInit(): void {
    this.getServerStatus();
    this.getSignedInUsers();
    this.getErrorLog();
  }

  refreshEverything() {
    this.serverStatus = undefined;
    this.errorLogList = undefined;
    this.signedInUserList.splice(0);

    this.getServerStatus();
    this.getSignedInUsers();
    this.getErrorLog();
  }

  async getServerStatus() {
    this.serverStatus = await this.serverService.getServerStatus();
  }

  async getErrorLog(errorCode?: string) {
    this.errorLogList = await this.serverService.getErrorLog(errorCode);
  }

  async getSignedInUsers() {
    this.signedInUserList = await this.serverService.getSignedInUsername("30s");
  }

  openMaintenaceModeModal(value: boolean, maintenanceType: string) {
    const modalRef = this.sharedService.openModal(MaintenanceModeToggleComponent);
    modalRef.componentInstance.turn_on = value;
    modalRef.componentInstance.maintenanceType = maintenanceType;
    modalRef.result.then(r => this.getServerStatus());

  }

  openDeployWebAppModal() {
    const modalRef = this.sharedService.openModal(DeployWebappComponent, "regularModal");
  }

}
